module.exports = __webpack_public_path__ + "fonts/LatoLatin-Regular.3cd3657.woff2";